import React from "react";
import StepZilla from "react-stepzilla";

import "./RoiCalculator.css";

import Step0 from './Step0';
import Step1 from './Step1';
import Step2 from './Step2';
import Summary from "./Summary";

class RoiCalculator extends React.Component {
  constructor(props) {
    super(props);

    const lastYear = new Date().getFullYear() - 1;
    const questions = [
      {
        name: "revenueOnline",
        type: "money",
        label: `What was your total web-based revenue in ${lastYear}?`,
        defaultValue: 0,
        stepIndex: 0
      },
      {
        name: "revenueTotal",
        type: "money",
        label: `What was your total revenue in ${lastYear}?`,
        defaultValue: 0,
        stepIndex: 0
      },
      {
        name: "averageOrderValue",
        type: "money",
        label: "What is your average order value?",
        defaultValue: 0,
        required: true,
        stepIndex: 1
      },
      {
        name: "websiteSessionsMthly",
        type: "number",
        label: "How many website visitor sessions do you average per month?",
        defaultValue: 0,
        stepIndex: 2
      }
    ];
    
    const storedAnswers = this.readStore();
    const answers = questions.map((question, i) => {
      let answer = storedAnswers[i];
      if (typeof answer === 'undefined' || answer === null) {
        return {
          isValid: false,
          value:(question.defaultValue || "").toString(),
          name: question.name,
          questionIndex:i
        };
      }

      return {
        isValid: answer.isValid || false,
        value: answer.value || (question.defaultValue || "").toString(),
        name: answer.name || question.name,
        questionIndex: answer.questionIndex || i
      };
    });

    const currentStepIndex = this.getCurrentStep();
    this.state = {
      revenueOnline: null,
      revenueTotal: null,
      averageOrderValue: null,
      websiteSessionsMthly: null,
      startingStep: currentStepIndex,
      currentStepIndex: currentStepIndex,
      questions: questions,
      answers: answers
    };

    this.updateStep = this.updateStep.bind(this);
    this.updateAnswers = this.updateAnswers.bind(this);
    this.updateStore = this.updateStore.bind(this);
    this.readStore = this.readStore.bind(this);
  }

  componentDidUpdate() {
    this.updateStore();
  }

  getCurrentStep() {
    let recordedStep = window.localStorage.getItem('step') ? parseInt(window.localStorage.getItem('step')) : 0;

    // Todo: validate answers of previous steps against the current

    return recordedStep;
  }

  updateStep(stepIndex) {
    this.setState(state => ({ 
      previousStepIndex: state.currentStepIndex,
      currentStepIndex: stepIndex 
    }));

    if (stepIndex > this.state.startingStep) {
      window.localStorage.setItem('step', stepIndex);
    }
  }

  updateAnswers(newAnswers) {
    this.setState(state => {
      const answers = state.answers;
      newAnswers.forEach(newAnswer => {
        newAnswer.value = newAnswer.value.replace(/,/g, '');
        if (newAnswer.value && newAnswer.value.trim().length) {
          answers[newAnswer.questionIndex] = newAnswer;
        }
      });

      return {answers};
    });
  }

  updateStore() {
    try {
      window.localStorage.setItem('revenueOnline', JSON.stringify(this.state.answers[0]));
      window.localStorage.setItem('revenueTotal', JSON.stringify(this.state.answers[1]));
      window.localStorage.setItem('averageOrderValue', JSON.stringify(this.state.answers[2]));
      window.localStorage.setItem('websiteSessionsMthly', JSON.stringify(this.state.answers[3]));
    } catch(ex) {
      console.log(ex);
    }
  }

  readStore() {
    try {
      return [
        JSON.parse(window.localStorage.getItem('revenueOnline')),
        JSON.parse(window.localStorage.getItem('revenueTotal')),
        JSON.parse(window.localStorage.getItem('averageOrderValue')),
        JSON.parse(window.localStorage.getItem('websiteSessionsMthly'))
      ];
    } catch(ex) {
      console.log(ex);
    }

    return new Array(4).fill(null);
  }

  render() {
    const getQuestionsForStep = (stepIndex) => {
      return this.state.questions.filter(question => question.stepIndex === stepIndex);
    };

    const getAnswersForStep = (stepIndex) => {
      var stepQuestions = getQuestionsForStep(stepIndex);
      return this.state.answers.filter(answer => stepQuestions.some(question => question.name === answer.name));
    };

    const skipStep2 = this.state.currentStepIndex === 2 && parseInt(this.state.answers[0].value) <= 0;
    const skipToStep = !skipStep2
      ? null
      : this.state.previousStepIndex > 2
        ? 1
        : 3;

    const steps = [
      { name: "Your Revenue", component: <Step0 questions={getQuestionsForStep(0)} answers={getAnswersForStep(0)} onSubmit={this.updateAnswers} /> },
      { name: "Your Company", component: <Step1 questions={getQuestionsForStep(1)} answers={getAnswersForStep(1)} onSubmit={this.updateAnswers}/> },
      { name: "Your Website", component: <Step2 questions={getQuestionsForStep(2)} answers={getAnswersForStep(2)} onSubmit={this.updateAnswers} skipToStep={skipToStep} /> },
      { name: "Your Potential", component: <Summary answers={this.state.answers} questions={this.state.questions} thankYouPageUrl={this.props.ThankYouPageLink} formUrl={this.props.FormUrl} /> }
    ];

    const isLastStep = this.state.currentStepIndex === 3;
    
    return (
      <div className="App">
        <div className="step-progress">
            <StepZilla 
                backButtonCls={`btn btn-next ${isLastStep ? "btn-default" : "btn-primary"}  btn-lg pull-left`}
                startAtStep={this.state.startingStep}
                steps={steps}
                stepsNavigation={false}
                // prevBtnOnLastStep={false}
                nextTextOnFinalActionStep={"Review"}
                onStepChange={(step) => this.updateStep(step)}
            />
          </div>
      </div>
    );
  }
}

export default RoiCalculator;


// WEBPACK FOOTER //
// ./src/Components/roi-calculator/RoiCalculator.jsx